import { groq } from '#imports';

export function getQuery({ limit = 30, offset = 0 } = {}) {
  return groq`*[_type == "news" && !(_id in path('drafts.**')) && isChronicle == true] | order(_updatedAt desc) [${offset}...${limit}]
              {
                slug,
                title,
                _updatedAt,
                publishedAt,
                titleColor
              }`;
}
